<div class="collapse-section">
    <a (click)="toggle()">
        {{ expanded ? collapseLabel : expandLabel }}
    </a>
    <div *ngIf="expanded" class="content">
        <ng-content></ng-content>
    </div>
</div>